module.exports = __webpack_public_path__ + "static/img/player_head_none.856246a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_none.jpg
// module id = 9fc8
// module chunks = 1